import { connect } from 'react-redux';
import { areParametersSelected } from 'store';

import SummaryTableParametersComponent from './Component';

const mapStateToProps = state => {
  return { areParametersSelected: areParametersSelected(state) };
};

export default connect(mapStateToProps)(SummaryTableParametersComponent);
